import { render, staticRenderFns } from "./creation-site-internet-coiffeur.vue?vue&type=template&id=2a55b509&"
import script from "./creation-site-internet-coiffeur.vue?vue&type=script&lang=js&"
export * from "./creation-site-internet-coiffeur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./creation-site-internet-coiffeur.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ListAdvantage: require('/app/components/ListAdvantage.vue').default})
